import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCanEditSelectedReservation } from '#/hooks/useCanEditSelectedReservation';
import { formatBookingNumber } from '#/hooks/useRefToBookingNumber';
import { RentalsReservationInstance } from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsReservation';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const BookingSummaryPanelTitle: React.FC<{ reservation: RentalsReservationInstance; showEdit?: boolean }> = observer(
    function BookingSummaryPanelTitleComponent({ reservation, showEdit = false }) {
        const isEditable = useCanEditSelectedReservation(showEdit);
        if (isEditable) {
            return (
                <Stack
                    sx={{
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        whiteSpace: 'nowrap',
                    }}
                >
                    <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'bold' }}>
                        Edit Booking Number:
                    </Typography>
                    {reservation ? (
                        <Typography
                            variant="subtitle2"
                            component="h4"
                            sx={{
                                ml: 1,
                            }}
                        >
                            {formatBookingNumber(reservation)}
                        </Typography>
                    ) : null}
                </Stack>
            );
        }

        return (
            <Stack
                sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    whiteSpace: 'nowrap',
                }}
            >
                <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 'bold' }}>
                    TRIP SUMMARY
                </Typography>
                {reservation ? (
                    <Typography
                        variant="subtitle2"
                        component="h4"
                        sx={{
                            ml: 1,
                        }}
                    >
                        Booking Number: {formatBookingNumber(reservation)}
                    </Typography>
                ) : null}
            </Stack>
        );
    }
);
